import React, { Component } from 'react';
import { MainRouter } from './MainRouter';

import { t, getCurrentLanguage } from '../locales/i18n';

import { ReactComponent as Logo } from '../Images/CountryMaltLogo.svg';
import { ReactComponent as MagnifyingGlass } from '../Images/MagnifyingGlass.svg';

export class Header extends Component {
    static displayName = Header.name;

    static setLoggedIn;

    constructor(props) {
        super(props);
        this.state = {
            loggedIn: localStorage.getItem('loggedIn'),
            language: getCurrentLanguage()
        };

        this.click = this.click.bind(this);
        this.handleLanguageChange = this.handleLanguageChange.bind(this);

        Header.setLoggedIn = (l) => {
            var state = this.state;
            state.loggedIn = l.toString();
            localStorage.setItem('loggedIn', l.toString());
            this.setState(state);
        };
    }

    handleLanguageChange(e) {
        const selectedLang = e.target.value;
        this.setState({ language: selectedLang });

        //redirect to home in chosen language
        if (selectedLang === 'fr') {
            window.location.href = '/fr';
        } else {
            window.location.href = '/';
        }
    }

    render() {
        return (
            <div className='header'>
                <div className='header-body'>
                    <a href="https://countrymaltgroup.com/" target="_blank" rel="noopener noreferrer"><Logo className='brand' /></a>
                    <div className='app-name'>
                        Track with Ease
                    </div>
                    <div className='app-name'>
                        <select
                            value={this.state.language}
                            onChange={this.handleLanguageChange}
                            className={'language-dropdown'}
                        >
                            <option value='en'>EN</option>
                            <option value='fr'>FR</option>
                        </select>
                    </div>
                </div>
                {this.state.loggedIn === 'true' &&
                    <div className='subHeader'>
                        <MagnifyingGlass onClick={this.click} />
                        &nbsp;
                        <a onClick={this.click}>{t('header.checkAnotherOrder')}</a>
                    </div>
                }
            </div>
        );
    }

    click() {
        Header.setLoggedIn(false);
        MainRouter.routeTo('/');
    }
}
